module.exports = __webpack_public_path__ + "static/media/BannerSeguimientoPng.2c21b4b6.png";